import Helpers from '@helpers';
import Drift from 'drift-zoom';
import videojs from 'video.js';

//const thumbnailCarouselInit = () => {
//    ($('#thumbnailCarousel') as any).owlCarousel({
//        rtl: false,
//        responsive: {
//            0: {
//                items: 3
//            },
//            400: {
//                items: 3
//            },
//            800: {
//                items: 3
//            },
//            1200: {
//                items: 5
//            }
//        },
//        nav: true,
//        navText: [
//            '<i class="fa fa-2x fa-angle-right" aria-hidden="true"></i>',
//            '<i class="fa fa-2x fa-angle-left" aria-hidden="true"></i>'
//        ],
//        slideBy: 'page',
//        navSpeed: 100,
//        dots: false
//    });
//};

const thumbnailCarouselInit = () => {
    ($('#thumbnailCarousel') as any).slick({
        slidesToShow: 5,
        centerMode: false,
        centerPadding: 0,
        infinite: false,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    infinite: false,
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 600,
                settings: {
                    infinite: false,
                    slidesToShow: 3
                }
            }
        ]
    })
}


const carouselClickHandler = () => {
    var thumnails = document.getElementsByClassName('thumbnail-item');
    for (var i = 0; i < thumnails.length; i++) {
        var selected = thumnails[i] as HTMLElement;
        selected.onclick = function (e) {
            var target = e.target as HTMLElement;
            var selectedClass = document.getElementsByClassName('thumbnail-wrapper')[0].getElementsByClassName('selected')[0];
            if (selectedClass) {
                selectedClass.classList.remove('selected');
            }
            target.parentElement.parentElement.classList.add('selected');

            if (target.classList.contains("video")) {
                ShowVideo(target);
            } else if (target.nodeName === 'IMG') {
                ShowImage(target);
            } else {
                showError();
            }
        }
    }
}

function ShowImage(element) {
    var targetSrc = element.src.replace('[Small]', '[large]');
    var targetAlt = element.alt;
    var targetContainer = document.getElementsByClassName('item-image-wrapper')[0];
    var targetElement = document.createElement('img') as HTMLImageElement;
    var currentElement = targetContainer.childNodes[1];

    targetElement.src = targetSrc;
    targetElement.alt = targetAlt;
    targetElement.classList.add('item-product-image');
    targetElement.classList.add('product-image');
    var dataZoom = targetSrc.replace('[large]', '');
    targetElement.setAttribute('data-zoom', dataZoom);
    targetContainer.replaceChild(targetElement, currentElement);
    addZoom();
}



function ShowVideo(element) {
    var videoUrl = element.getAttribute('data-video-url');
    var videoImgUrl = element.getAttribute('data-video-img');
    var videoSubtitleUrl = element.getAttribute('data-video-subtitle');

    var targetContainer = document.getElementsByClassName('item-image-wrapper')[0] as HTMLElement;
    var computedStyle = getComputedStyle(targetContainer);
    var elementHeight = targetContainer.clientHeight;  // height with padding
    var elementWidth = targetContainer.clientWidth;   // width with padding

    elementHeight -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
    elementWidth -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);


    var videoComponentString = "<video id='video_master_item' class='video-js vjs-fluid' controls preload='auto' width='" + elementWidth + "' height ='" + elementHeight + "'  data-setup='{ }' >" ;
     videoComponentString += "<source src ='" + videoUrl + ".mp4" + "'" + " type ='video/mp4'   >";
     videoComponentString += "<source src ='" + videoUrl + ".webm" + "'" + " type ='video/webm'   >";
     videoComponentString += "<track  label='Persian' kind ='subtitles' srclang = 'fa' default  src='" + videoSubtitleUrl + "' >" ;
    videoComponentString += "</video>";





    var targetElement = createElementFromHTML(videoComponentString) as HTMLElement;
    var currentElement = targetContainer.childNodes[1];
    targetContainer.replaceChild(targetElement, currentElement);


    // Play Video
   var player = videojs(document.querySelector("#video_master_item"));
    player.play();
    

}

function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
}

function showError() {
    var targetContainer = document.getElementsByClassName('item-image-wrapper')[0];
    var targetElement = document.createElement('span') as HTMLSpanElement;
    var currentElement = targetContainer.childNodes[1];
    targetElement.innerHTML = "متأسفانه خطایی پیش آمده است.";
    targetContainer.replaceChild(targetElement, currentElement);
}

function addZoom () {
    const productImage = document.querySelector('.product-image');
    if (productImage && window.innerWidth > 992) {
        const leftPane = document.querySelector('.summary-left-pane');
        new Drift(productImage, {
            paneContainer: leftPane,
            inlinePane: false,
            hoverBoundingBox: true
        });
    }
}


const initGallery = () => {
    thumbnailCarouselInit();
    carouselClickHandler();
    //thumbnailClickHandler();
    //galleryImageLoadHandler();
    //galleryCloseHandler();
};

export {
    initGallery
};
